export const StatCard = ({ title, value, subtitle, icon: Icon, alert }) => (
  <div className={`glass-card p-4 ${alert ? "border-[#D4AF37]/30" : ""}`}>
    <div className="flex items-start justify-between">
      <div>
        <p className="text-3xl text-[#EDEDED] font-medium">{value}</p>
        <p className="text-sm text-[#A1A1AA] mt-1">{title}</p>
        {subtitle && <p className="text-xs text-[#71717A] mt-0.5">{subtitle}</p>}
      </div>
      <div className={`p-2 rounded-lg ${alert ? "bg-[#D4AF37]/10" : "bg-[#18181B]"}`}>
        <Icon className={`w-5 h-5 ${alert ? "text-[#D4AF37]" : "text-[#71717A]"}`} />
      </div>
    </div>
  </div>
);
